// Due-date pill styling — Jira-style traffic-light cues so cards
// communicate urgency at a glance. One source of truth for every place
// (Kanban card, list view, sidebar) that renders a due-date chip.

export function getDueDateMeta(dueDate) {
  if (!dueDate) return null;
  const d = new Date(dueDate);
  if (Number.isNaN(d.getTime())) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const dn = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const diffDays = Math.round((dn - today) / 86400000);
  let bucket, className, icon;
  if (diffDays < 0) {
    bucket = 'overdue';
    className = 'bg-red-50 text-red-700 ring-1 ring-red-200 font-semibold';
    icon = 'alert';
  } else if (diffDays === 0) {
    bucket = 'today';
    className = 'bg-orange-50 text-orange-700 ring-1 ring-orange-200 font-semibold';
    icon = 'alert';
  } else if (diffDays <= 2) {
    bucket = 'soon';
    className = 'bg-amber-50 text-amber-800 ring-1 ring-amber-200 font-medium';
    icon = 'clock';
  } else {
    bucket = 'future';
    className = 'bg-zinc-50 text-zinc-600 ring-1 ring-zinc-200';
    icon = 'clock';
  }
  // Pretty short label for cards — "May 15" or "Today" or "3d overdue".
  let label;
  if (diffDays === 0) label = 'Today';
  else if (diffDays === 1) label = 'Tomorrow';
  else if (diffDays === -1) label = '1d overdue';
  else if (diffDays < 0) label = `${-diffDays}d overdue`;
  else label = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  return { bucket, className, icon, label, diffDays, date: d };
}
